// import React, { useEffect, useState } from "react";
// import { Tweet } from "react-tweet";
// import { Get_Api } from "../../API_URL";

// function TwitterCompoent() {
//   const [AllTweetIds, setAllTweetIds] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);

//   const Get_All_TweetIds = async () => {
//     try {
//       setIsLoading(true);
//       const response = await Get_Api("api/admin/GetAllTwitterPost");
//       setAllTweetIds(response?.data || []);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     Get_All_TweetIds();
//   }, []);

//   if (!isLoading && AllTweetIds.length === 0) {
//     return null;
//   }

//   return (
//     <div className="w-full py-10 px-4">
//       <div className="max-w-7xl mx-auto">
//         <h2 className="text-2xl md:text-3xl font-bold text-center mb-2">
//           Live Signal (Twitter)
//         </h2>
//         <p
//           className="text-center font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] lg:leading-[30px] tracking-[-0.22px] text-[#05003E] pb-[20px] lg:pb-[31px]"
//         >
//           What we are tracking across technology, policy, and industry.
//         </p>
//         {isLoading && (
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//             {[...Array(3)].map((_, i) => (
//               <div
//                 key={i}
//                 className="bg-white rounded-xl shadow-md p-4 animate-pulse"
//               >
//                 <div className="h-4 bg-gray-200 rounded w-3/4 mb-3" />
//                 <div className="h-4 bg-gray-200 rounded w-full mb-2" />
//                 <div className="h-4 bg-gray-200 rounded w-5/6" />
//               </div>
//             ))}
//           </div>
//         )}
//         {!isLoading && (
//           <div className="max-h-[600px] overflow-y-auto pr-2">
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//               {AllTweetIds.map((tweet, index) => (
//                 <div key={index}>
//                   <Tweet id={tweet?.TweetId} />
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>

//   );
// }

// export default TwitterCompoent;


// import React, { useEffect, useState } from "react";
// import { TwitterTweetEmbed } from "react-twitter-embed";
// import { Get_Api } from "../../API_URL";

// function TwitterCompoent() {
//   const [allTweetIds, setAllTweetIds] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);

//   const Get_All_TweetIds = async () => {
//     try {
//       setIsLoading(true);

//       const response = await Get_Api("api/admin/GetAllTwitterPost");
//       setAllTweetIds(response?.data || []);
//     } catch (error) {
//       console.error("Error fetching tweets:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     Get_All_TweetIds();
//   }, []);

//   if (!isLoading && allTweetIds?.length === 0) {
//     return null;
//   }

//   return (
//     <div className="w-full py-10 px-4">
//       <div className="max-w-7xl mx-auto">

//         <h2 className="text-2xl md:text-3xl font-bold text-center mb-2">
//           Live Signal (Twitter)
//         </h2>

//         <p className="text-center text-[14px] sm:text-[15px] lg:text-[16px] text-[#05003E] pb-6">
//           What we are tracking across technology, policy, and industry.
//         </p>

//         {isLoading ? (
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//             {[...Array(3)]?.map((_, i) => (
//               <div
//                 key={i}
//                 className="bg-white rounded-xl shadow-md p-4 animate-pulse"
//               >
//                 <div className="h-4 bg-gray-200 rounded w-3/4 mb-3" />
//                 <div className="h-4 bg-gray-200 rounded w-full mb-2" />
//                 <div className="h-4 bg-gray-200 rounded w-5/6" />
//               </div>
//             ))}
//           </div>
//         ) : (
//           <div className="max-h-[700px] overflow-y-auto">
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

//               {allTweetIds?.map((tweet) => (
//                 <div
//                   key={tweet?._id}
//                   className="bg-white rounded-2xl overflow-hidden shadow-md"
//                 >
//                   <TwitterTweetEmbed
//                     tweetId={tweet?.TweetId}
//                     options={{
//                       theme: "light",
//                       width: "100%",
//                     }}
//                     placeholder={
//                       <div className="p-4 animate-pulse w-100">
//                         Loading Tweet...
//                       </div>
//                     }
//                   />
//                 </div>
//               ))}

//             </div>
//           </div>
//         )}

//       </div>
//     </div>
//   );
// }

// export default TwitterCompoent;

import React, { useEffect, useState } from "react";
import { TwitterTweetEmbed } from "react-twitter-embed";
import { Get_Api } from "../../API_URL";

function TwitterCompoent() {
  const [allTweetIds, setAllTweetIds] = useState([]);
  const [visibleTweets, setVisibleTweets] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // how many tweets load at once
  const CHUNK_SIZE = 6;

  const Get_All_TweetIds = async () => {
    try {
      setIsLoading(true);

      const response = await Get_Api("api/admin/GetAllTwitterPost");

      const tweets = response?.data || [];

      setAllTweetIds(tweets);

      // initial visible tweets
      setVisibleTweets(tweets.slice(0, CHUNK_SIZE));
    } catch (error) {
      console.error("Error fetching tweets:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    Get_All_TweetIds();
  }, []);

  // load more when scrolling near bottom
  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    const reachedBottom =
      scrollTop + clientHeight >= scrollHeight - 200;

    if (
      reachedBottom &&
      visibleTweets.length < allTweetIds.length
    ) {
      const nextTweets = allTweetIds.slice(
        0,
        visibleTweets.length + CHUNK_SIZE
      );

      setVisibleTweets(nextTweets);
    }
  };

  if (!isLoading && allTweetIds.length === 0) {
    return null;
  }

  return (
    <div className="w-full py-10 px-4">
      <div className="max-w-7xl mx-auto">

        <h2 className="text-2xl md:text-3xl font-bold text-center mb-2">
          From our feed
        </h2>

        <p className="text-center text-[14px] sm:text-[15px] lg:text-[16px] text-[#05003E] pb-6">
          Daily updates on the U.S.–India strategic relationship. Follow @TheIndUSTech on X.
        </p>

        {isLoading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(6)].map((_, i) => (
              <div
                key={i}
                className="bg-white rounded-xl shadow-md p-4 animate-pulse h-[300px]"
              >
                <div className="h-4 bg-gray-200 rounded w-3/4 mb-3" />
                <div className="h-4 bg-gray-200 rounded w-full mb-2" />
                <div className="h-4 bg-gray-200 rounded w-5/6" />
              </div>
            ))}
          </div>
        ) : (
          <div
            className="max-h-[700px] overflow-y-auto pr-2"
            onScroll={handleScroll}
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

              {visibleTweets.map((tweet) => (
                <div
                  key={tweet?._id}
                  className="bg-white rounded-2xl overflow-hidden shadow-md"
                >
                  <TwitterTweetEmbed
                    tweetId={tweet?.TweetId}
                    options={{
                      theme: "light",
                      width: "100%",
                      conversation: "none",
                    }}
                    placeholder={
                      <div className="h-[300px] flex items-center justify-center animate-pulse">
                        Loading Tweet...
                      </div>
                    }
                  />
                </div>
              ))}

            </div>

            {visibleTweets.length < allTweetIds.length && (
              <div className="text-center py-6 text-gray-500">
                Loading more tweets...
              </div>
            )}
          </div>
        )}

      </div>
    </div>
  );
}

export default TwitterCompoent;